import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

const GymCard = ({ facility_name = "", logo_img = "", location = { city: "", state: "", country: "" }, rating = 0, reviews_count = 0, notes = "", amenities = [], phone_no = "", assured = false, user_name = null, ...gymProps }) => {

    const locality = `${!!location?.city ? location?.city + ', ' : ''}${!!location?.state ? location?.state + ', ' : ''}${!!location?.country ? location?.country : ''}`;

    const ContactButton = () => {
        return (
            <a
                onClick={(e) => {
                    e.stopPropagation(); // ⛔ stop parent click
                }}
                href={`tel:${phone_no}`}
                className="flex-shrink-0 group flex items-center bg-white border border-gray-300 text-gray-900 font-medium p-[0.15rem] rounded-[0.6rem] rounded-tr-[0.3rem] shadow-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 transition duration-200"
            >
                <span className="hidden md:flex px-2 font-urbanist text-xs text-black font-semibold mr-1">Contact Now</span>
                <span className="flex items-center justify-center w-5 h-5 bg-black rounded-[0.53rem] rounded-tr-[0.3rem] p-1">
                    <img
                        className="transition-transform group-hover:scale-105"
                        src="/assets/individual/Call.png"
                        alt="Contact"
                    />
                </span>
            </a>
        )
    }

    const LocationAndAmenities = () => {
        return (
            <Fragment>
                <div className="md:w-1/3 flex flex-col justify-between items-start">
                    <p className="text-gray-300 text-sm font-medium">Location</p>
                    <p className="text-white font-semibold text-[0.75rem]">{locality}</p>
                </div>

                {/* Column 3: Amenities */}
                <div className="md:w-2/3 flex flex-col justify-start mt-3 md:mt-0 md:pl-3">
                    <p className="text-gray-300 text-sm font-medium">Amenities</p>
                    <p className="text-white text-[0.75rem] leading-snug line-clamp-4">
                        {(amenities || []).map((amt) => amt.title).join(" | ")}
                    </p>
                </div>
            </Fragment>
        )
    }

    return (
        <Link to={`/gym/profile/${user_name}`} className="bg-gradient-radial p-3 rounded-xl font-urbanist flex flex-col md:flex-row items-start w-full max-w-6xl mx-auto mb-6 gap-3">
            <div className="flex flex-1 flex-row justify-center items-start gap-3">
                {/* Gym Image */}
                <div className="flex-shrink-0 w-20 h-20 rounded-2xl rounded-tr-md overflow-hidden bg-gray-700 flex items-center justify-center">
                    {/* Placeholder for actual image */}
                    <img src={logo_img} alt="Gym" className="w-full h-full object-cover" />
                </div>

                {/* Main Content Area */}
                <div className="flex-grow flex flex-row flex-wrap md:flex-nowrap gap-x-4 md:gap-x-6 items-start">
                    {/* Column 1: Name, Assured Tag, Description */}
                    <div className="md:w-48 flex flex-col items-start">
                        <div className="flex items-center mb-1">
                            <div className="text-md font-medium text-white">{facility_name}</div>
                            {assured && (
                                <span className="ml-3 px-3 py-1 bg-white text-black text-xs font-semibold rounded-full">
                                    Assured
                                </span>
                            )}
                        </div>
                        <p className="text-[0.75rem] text-gray-400 leading-relaxed line-clamp-4">
                            {location?.full_address}
                        </p>
                    </div>

                    {/* Column 2: Location and Ratings */}
                    <div className='hidden md:flex flex-1 flex-col md:flex-row justify-between items-start'>
                        <LocationAndAmenities />
                    </div>
                </div>

                {/* Contact Now Button (Right-aligned) */}
                <ContactButton />
            </div>
            <div className='md:hidden flex flex-col md:flex-row items-start'>
                <LocationAndAmenities />
            </div>
        </Link>
    );
};

export { GymCard };